import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../Styles/JanataDarbarForm.css";
import { fileAPI, janataDarbarAPI } from "../../api/index"; // adjust path to match your project

// Shared mandal id -> name lookup. CONFIRM these ids match your actual
// `mandals` table rows — these are placeholders in dropdown order.
export const MANDALS = [
  { id: 1, name: "Kandukur" },
  { id: 2, name: "Lingasamudram" },
  { id: 3, name: "Gudluru" },
  { id: 4, name: "Ulavapadu" },
  { id: 5, name: "Voletivaripalem" },
];

const STATUS_TO_BACKEND = {
  Pending: "pending",
  "In Progress": "in_progress",
  Resolved: "resolved",
  Referred: "referred",
};

const JanataDarbarForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    voterId: "",
    age: "",
    gender: "",
    category: "",
    village: "",
    mandalId: "",
    date: "",
    issueDescription: "",
    actionTaken: "",
    status: "",
  });
  const [file, setFile] = useState(null);

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "photo") {
      setFile(files[0] || null);
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (
      !formData.name ||
      !formData.category ||
      formData.category === "Select Category" ||
      !formData.village ||
      !formData.mandalId ||
      !formData.date ||
      !formData.status ||
      formData.status === "Select Status" ||
      !formData.issueDescription
    ) {
      setError("Please fill all required fields marked with *.");
      return;
    }

    setSubmitting(true);
    try {
      let documentUrl = null;
      if (file) {
        const uploadRes = await fileAPI.upload(file, "janata_darbar");
        documentUrl =
          uploadRes.data?.url ||
          uploadRes.data?.file_url ||
          uploadRes.data?.photo_url;
      }

      const mandalName = MANDALS.find(
        (m) => String(m.id) === String(formData.mandalId)
      )?.name;

      await janataDarbarAPI.create({
        visitor_name: formData.name,
        mobile_number: formData.mobile || null,
        epic_no: formData.voterId || null,
        age: formData.age ? Number(formData.age) : null,
        gender: formData.gender && formData.gender !== "Select Gender" ? formData.gender : null,
        issue_category: formData.category,
        village_name: formData.village,
        mandal_name: mandalName,
        visit_date: formData.date, // <input type="date"> already gives YYYY-MM-DD
        status: STATUS_TO_BACKEND[formData.status] ?? "pending",
        issue_description: formData.issueDescription,
        action_taken: formData.actionTaken || null,
        document_url: documentUrl,
      });

      navigate("/dashboard/JanataDarbarTable");
    } catch (err) {
      console.error("Visitor save failed:", err);
      setError(
        err.response?.data?.detail || err.message || "Something went wrong while saving the visitor."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="darbar-form-container">
      <div className="darbar-form-card">
        <div className="darbar-form-header">
          <h2>Add New Janata Darbar Visitor</h2>
          <p>Log citizen grievances and issues raised during public hearings</p>
          <button
            className="darbar-back-btn"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>

        {error && <div className="darbar-form-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="darbar-form-grid">

            <div className="darbar-form-group">
              <label>Visitor Name *</label>
              <input
                type="text"
                name="name"
                placeholder="Enter Visitor Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="darbar-form-group">
              <label>Mobile Number</label>
              <input
                type="tel"
                name="mobile"
                placeholder="Enter Mobile Number"
                maxLength="10"
                value={formData.mobile}
                onChange={handleChange}
              />
            </div>

            <div className="darbar-form-group">
              <label>Voter ID</label>
              <input
                type="text"
                name="voterId"
                placeholder="Enter Voter ID"
                value={formData.voterId}
                onChange={handleChange}
              />
            </div>

            <div className="darbar-form-group">
              <label>Age</label>
              <input
                type="number"
                name="age"
                placeholder="Enter Age"
                value={formData.age}
                onChange={handleChange}
              />
            </div>

            <div className="darbar-form-group">
              <label>Gender</label>
              <select name="gender" value={formData.gender} onChange={handleChange}>
                <option>Select Gender</option>
                <option>Male</option>
                <option>Female</option>
                <option>Other</option>
              </select>
            </div>

            <div className="darbar-form-group">
              <label>Issue Category *</label>
              <select name="category" value={formData.category} onChange={handleChange} required>
                <option value="">Select Category</option>
                <option>Land Dispute</option>
                <option>Pension</option>
                <option>Financial Aid</option>
                <option>Employment</option>
                <option>Health</option>
                <option>Police Matter</option>
                <option>Personal</option>
                <option>Other</option>
              </select>
            </div>

            <div className="darbar-form-group">
              <label>Village *</label>
              <input
                type="text"
                name="village"
                placeholder="Enter Village"
                value={formData.village}
                onChange={handleChange}
                required
              />
            </div>

            <div className="darbar-form-group">
              <label>Mandal *</label>
              <select name="mandalId" value={formData.mandalId} onChange={handleChange} required>
                <option value="">Choose Mandal</option>
                {MANDALS.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="darbar-form-group">
              <label>Visit Date *</label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </div>

            <div className="darbar-form-group">
              <label>Status *</label>
              <select name="status" value={formData.status} onChange={handleChange} required>
                <option value="">Select Status</option>
                <option>Pending</option>
                <option>In Progress</option>
                <option>Resolved</option>
                <option>Referred</option>
              </select>
            </div>

            <div className="darbar-form-group">
              <label>Upload Photo / Document</label>
              <input
                type="file"
                name="photo"
                accept="image/*,.pdf"
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="darbar-form-group darbar-full-width">
            <label>Issue Description *</label>
            <textarea
              rows="3"
              name="issueDescription"
              placeholder="Describe the issue raised by the visitor"
              value={formData.issueDescription}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <div className="darbar-form-group darbar-full-width">
            <label>Action Taken / Referred To</label>
            <textarea
              rows="3"
              name="actionTaken"
              placeholder="Enter action taken, department referred to, or instructions given"
              value={formData.actionTaken}
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="darbar-btn-group">
            <button type="submit" className="darbar-submit-btn" disabled={submitting}>
              {submitting ? "Submitting..." : "Submit"}
            </button>
            <button
              type="button"
              className="darbar-reset-btn"
              onClick={() => {
                setFormData({
                  name: "",
                  mobile: "",
                  voterId: "",
                  age: "",
                  gender: "",
                  category: "",
                  village: "",
                  mandalId: "",
                  date: "",
                  issueDescription: "",
                  actionTaken: "",
                  status: "",
                });
                setFile(null);
                setError("");
              }}
            >
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default JanataDarbarForm;